import { Avatar as BaseAvatar, AvatarFallback, AvatarImage, cn } from '@sib/ui';
import { getInitials } from '@sib/utils';

export interface AvatarProps {
  className?: string;
  avatarImageProps: {
    avatarUrl?: string;
    className?: string;
  };
  avatarFallbackProps: {
    initials?: string;
    name?: string;
    className?: string;
  };
}

export const Avatar = ({
  className,
  avatarImageProps,
  avatarFallbackProps,
}: AvatarProps) => (
  <BaseAvatar className={cn('size-24', className)}>
    <AvatarImage
      src={avatarImageProps?.avatarUrl}
      alt={avatarFallbackProps?.name}
      className={cn(
        'h-full w-full object-cover object-center',
        avatarImageProps?.className
      )}
    />
    <AvatarFallback
      className={cn('text-xl font-bold', avatarFallbackProps?.className)}
    >
      {avatarFallbackProps.initials || getInitials(avatarFallbackProps?.name)}
    </AvatarFallback>
  </BaseAvatar>
);

Avatar.displayName = 'Avatar';
